import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'

@Pipe({
    name: 'minusSignToParens'
})
export class MinusSignToParens implements PipeTransform {

    transform(value: any, args?: any): any {
        try {
            return value.charAt(0) === '-' ?
                '(' + value.substring(1, value.length) + ')' :
                value;
        } catch (e) {
            return '';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/minus-sign-to-parens.pipe.ts